import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import settingsService from '../services/settingsService'

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref({})

  const loadSettings = async () => {
    try {
      const result = await settingsService.load()
      settings.value = result.settings
    } catch (error) {
      console.error('Error while fetching settings:', error)
    }
  }

  return {
    settings,
    loadSettings
  }
})
